import axiosInstance from '../services/AxiosInstance';

export function getPolicies(pageNum = 1, pageSize = 10, searchTerm = "", filterQuery = "") {
    return axiosInstance.get(`policy?pageNum=${pageNum}&pageSize=${pageSize}&search=${searchTerm}`);
}

export function getAllPolicies() {
    return axiosInstance.get(`policy/all`);
}

export function deletePolicy(policyId) {
    return axiosInstance.delete(`policy/${policyId}`);
}

export function createPolicy(policyData) {
    return axiosInstance.post(`policy`,policyData);
}

export function updatePolicy(policyId, policyData) {
    return axiosInstance.put(`policy/${policyId}`,policyData);
}
